<template>
  <div>
    <!-- banner部分 -->
    <!-- <div class="headBanner">
      <div class="headClass"></div>
    </div> -->

    <!-- 区域位置 -->
    <div class="wzBox">
      <div class="wzBoxCar">
        <h2>各区域联系方式及业务布局</h2>
        <img src="@/assets/dw.png" alt="" />
        <!-- 西安 -->
        <div class="city city1">
          <span>西安</span>
          <p>地址：高新区万科金域国际A座515</p>
          <p>电话：186-0297-8880</p>
        </div>
        <div class="city city2">
          <span>成都</span>
          <p>地址：高新区环球中心w5区1204—1206</p>
          <p>电话：189-8000-0761</p>
        </div>
        <div class="city city3">
          <span>南宁</span>
          <p>地址：青秀区东葛路10号2楼</p>
          <p>电话：157-7711-0798</p>
        </div>
        <div class="city city4">
          <span>昆明</span>
          <p>地址：官渡区知春路263号</p>
          <p>电话：138-8878-5544</p>
        </div>
      </div>
    </div>
    <!-- 公司资质 -->
    <div class="CompanyQualificationBox">
      <h1>公司资质</h1>
      <ul class="CompanyQualification">
        <li v-for="(item, index) in list" :key="index">
          <img :src="item.url" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { url: require('../assets/zz1.png') },
        { url: require('../assets/zz2.png') },
        { url: require('../assets/zz3.png') },
        { url: require('../assets/zz4.png') },
        { url: require('../assets/zz5.png') },
        { url: require('../assets/zz6.png') },
        { url: require('../assets/zz7.png') },
        { url: require('../assets/zz8.png') },
        { url: require('../assets/zz9.png') },
        { url: require('../assets/zz10.png') },
        { url: require('../assets/zz11.png') },
        { url: require('../assets/zz12.png') },
        { url: require('../assets/zz13.png') },
        { url: require('../assets/zz14.png') },
        { url: require('../assets/zz15.png') },
        { url: require('../assets/zz16.png') },
        { url: require('../assets/zz17.png') },
        { url: require('../assets/zz18.png') }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
// .headBanner {
//   background: #04283e;
//   background: url('../assets/lianxi.png');
//   background-size: 100% 100%;
//   .headClass {
//     width: 1200px;
//     height: 400px;
//     margin: 0 auto;
//   }
// }
.CompanyQualificationBox {
  width: 100%;
  .CompanyQualification {
    margin: 0 auto;
    width: 1200px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0;
    li {
      width: 15%;
      height: 300px;
      margin-right: 20px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 300px;
      }
    }
  }
}
.wzBox {
  width: 100%;
  // .carousel{
  //   img{
  //     width: 200px;
  //     height: 300px;
  //   }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
  opacity: 0.2;
}
.el-carousel__item:nth-child(2n) {
  background-color: #dfe5ec;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #dfe5ec;
}
.wzBoxCar {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  .city {
    width: 300px;
    height: 70px;
    border: 1px solid #ccc;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    padding: 6px;
    box-shadow: 5px 5px 5px rgb(165, 165, 165);
    span {
      font-size: 18px;
      color: #000;
      font-weight: 600;
    }
    p {
      margin: 2px 0;
    }
  }
  .city1 {
    position: absolute;
    right: 0;
    top: 250px;
  }
  .city2 {
    position: absolute;
    right: 0;
    top: 345px;
  }
  .city3 {
    position: absolute;
    right: -8px;
    bottom: 22px;
  }
  .city4 {
    position: absolute;
    left: 145px;
    bottom: 67px;
  }
}
</style>
